import { inject, Injectable } from '@angular/core';
import { AuDialogService } from '@app/core/services/au-dialog.service';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class EditTitleService {
	// Service to handle editing titles in the application it should not know
	// about the current title of the entity, it should only inform when it has been changed.
	private readonly dialogService = inject(AuDialogService);

	openEditTitleDialog(currentTitle: string): Observable<string> {
		const dialogRef = this.dialogService.openEditTitleDialog(currentTitle);

		return dialogRef.afterClosed() as Observable<string>;
	}
}
